import { Checkbox, Tooltip, Typography } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import Button from 'components/new-ui/base/button/Button';
import Tag from 'components/new-ui/base/tag/Tag';
import { Ics2Referral } from 'store/declarations/eu/ics2/customs-requests/types';
import { isReferralEditable } from 'store/declarations/eu/ics2/customs-requests/utils';
import { getReferralStatusColor, getReferralStatusLabel, getReferralTypeLabel } from './referralLabels';
import { ReferralReference, ReferralRowLayout } from '../styles';

type Props = {
    referral: Ics2Referral;
    isSelected: boolean;
    draftErrors?: string[];
    onToggleSelected: () => void;
    onOpen: () => void;
};

/**
 * One referral request reference - the unit of work in this domain. A single IE3Q02/IE3Q03 carries
 * up to 999 of them and each is answered on its own, so they are listed rather than summarised.
 */
const ReferralRow = ({ referral, isSelected, draftErrors, onToggleSelected, onOpen }: Props) => {
    const editable = isReferralEditable(referral.status);

    return (
        <ReferralRowLayout>
            <Checkbox
                checked={isSelected}
                disabled={!editable}
                onChange={onToggleSelected}
                aria-label={`Include ${referral.referralRequestReference} in the response`}
            />

            <ReferralReference $isEditable={editable}>{referral.referralRequestReference}</ReferralReference>

            <Typography.Text type="secondary">({getReferralTypeLabel(referral.requestType)})</Typography.Text>

            <span>
                <Tag status={getReferralStatusColor(referral.status)} label={getReferralStatusLabel(referral.status)} />
                {editable && Boolean(draftErrors?.length) && (
                    <Tooltip title={draftErrors?.join('; ')}>
                        <span>
                            <Tag status="error" label="Incomplete" />
                        </span>
                    </Tooltip>
                )}
            </span>

            <span />

            <Button type="link" style={{ color: 'var(--brand-6)' }} onClick={onOpen}>
                {editable ? 'Add Details' : 'See Details'} <RightOutlined />
            </Button>
        </ReferralRowLayout>
    );
};

export default ReferralRow;
